import "./Home.module.css";
import CabecalhoPrincipal from "@/reusable_sections/Header";
import InovacaoEmDestaque from "./sections/InovacaoEmDestaque";
import TecnologiaQueTrabalhaPorVoce from "./sections/TecnologiaQueTrabalhaPorVoce";
import CategoriasDeInvestimento from "./sections/CategoriasDeInvestimento";
import DestaquesDaFabrica from "./sections/DestaquesDaFabrica";
import NossaAgilidadeEmNumeros from "./sections/NossaAgilidadeEmNumeros";
import ProntoParaTransformarSeuAtendimento from "./sections/ProntoParaTransformarSeuAtendimento";
import CorporateFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <CabecalhoPrincipal />
      <InovacaoEmDestaque />
      <NossaAgilidadeEmNumeros />
      <TecnologiaQueTrabalhaPorVoce />
      <CategoriasDeInvestimento />
      <DestaquesDaFabrica />
      <ProntoParaTransformarSeuAtendimento />
      <CorporateFooter />
    </div>;
}